import React, { Component } from 'react';
import {
  Container,
  Dimmer,
  Grid,
  Loader,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import SharedNote from '../../../components/SharedNote';
import { SOURCE_OF_FINANCE_STATUS_MAP } from '../../../constants/sourceOfFinanceStatuses';
import BOOKING_DEFAULT from '../../../structs/booking';
import GridDivider from '../../../components/UpdatedComponents/Basic/UCBGridDivider';
import AttachmentItem from '../../../components/AttachmentItem';
import { fetchM } from '../../../actions/fetchM';
import config from '../../../../config';


class Info extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  mounted = false;
  // eslint-disable-next-line react/no-unused-prop-types
  static propTypes = {
    data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    loading: PropTypes.bool,
    routeParamsID: PropTypes.string,
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    // appConfig: state.appConfig,
    // cancellationReasons: state.cancellationReasons,
  })
  static getDerivedStateFromProps(props) {
    return Info.getPropsToState(props);
  }
  static getPropsToState = (props) => {
    const loading = props.loading;

    let rawData = props.data;
    if (Array.isArray(rawData)) {
      rawData = rawData[0];
    }
    const data = Object.assign({}, BOOKING_DEFAULT, rawData);

    return {
      data,
      loading,
    };
  }
  constructor(props) {
    super(props);
    const state = Info.getPropsToState(props);
    this.state = {
      ...state,
      formAttachments: [],
      formAttachmentsLoading: false,
      formAttachmentsError: null,
    };
    this.refOpportunityNote = null;
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchFormAttachments();
  }

  componentDidUpdate(prevProps) {
    const prevID = prevProps.routeParamsID;
    const currID = this.props.routeParamsID;
    if (currID && currID !== prevID) {
      this.fetchFormAttachments();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  fetchFormAttachments = async () => {
    const { store } = this.context;
    const id = this.props.routeParamsID || (this.state.data && this.state.data.id);
    if (!id || !store) {
      if (this.mounted) this.setState({ formAttachmentsLoading: false });
      return;
    }

    this.setState({ formAttachmentsLoading: true, formAttachments: [], formAttachmentsError: null });
    try {
      const res = await store.dispatch(fetchM(
        `/shared_medias/?parent_type=opportunity&parent_id=${id}&file_type=opportunity_form`,
        {
          method: 'GET',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
        },
      ));
      const attachments = await res.json();
      if (this.mounted) {
        if (!res.ok) {
          this.setState({ formAttachments: [], formAttachmentsError: true });
        } else {
          const normalizedAttachments = Array.isArray(attachments) ? attachments : [];
          this.setState({
            formAttachments: normalizedAttachments,
            formAttachmentsError: (attachments !== null && !Array.isArray(attachments)) ? true : null,
          });
        }
      }
    } catch (err) {
      if (this.mounted) {
        this.setState({ formAttachments: [], formAttachmentsError: true });
      }
    } finally {
      if (this.mounted) {
        this.setState({ formAttachmentsLoading: false });
      }
    }
  }

  getAttachmentUrl = (id, fileName) => {
    if (!fileName) {
      return null;
    }
    const bookApiURL = config.get('bookApiURL');
    const encodedFileName = encodeURIComponent(fileName);
    return `${bookApiURL}/shared_medias/${id}/file/${encodedFileName}?dl=true`;
  }
  setRefOpportunityNote = (ref) => {
    this.refOpportunityNote = ref;
  };

  render() {
    const { t, routeParamsID } = this.props;
    const { data, formAttachments, formAttachmentsLoading, formAttachmentsError } = this.state;
    const sourceOfFinanceStatus = (data.sr_source_of_finance && SOURCE_OF_FINANCE_STATUS_MAP[data.sr_source_of_finance]) ? t(SOURCE_OF_FINANCE_STATUS_MAP[data.sr_source_of_finance].text, { ns: TRANSLATION_FILES.constants }) : 'N/A';
    return (
      <Container>
        <Grid>
          <Dimmer style={{ zIndex: 10 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column className="opportunity-detail-fields" mobile={16} tablet={16} computer={12}>
              <Grid>
                <Grid.Row className="uc-grid-title-row">
                  <Grid.Column width={16}>
                    {t('Booking Details', { ns: TRANSLATION_FILES.screens })}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="uc-grid-detail-row">
                  <Grid.Column mobile={6} tablet={4} computer={3}>
                    {t('Booking ID', { ns: TRANSLATION_FILES.screens })}
                  </Grid.Column>
                  <Grid.Column mobile={10} tablet={4} computer={5}>
                    <span>{data.sr_code || '-'}</span>
                  </Grid.Column>
                  <Grid.Column mobile={6} tablet={4} computer={3}>
                    {t('Source of Finance', { ns: TRANSLATION_FILES.screens })}
                  </Grid.Column>
                  <Grid.Column mobile={10} tablet={4} computer={5}>
                    <span>{sourceOfFinanceStatus}</span>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="uc-grid-detail-row">
                  <Grid.Column mobile={6} tablet={4} computer={3}>
                    {t('Project', { ns: TRANSLATION_FILES.screens })}
                  </Grid.Column>
                  <Grid.Column mobile={10} tablet={12} computer={13}>
                    <span>{data.project_name}</span>
                  </Grid.Column>
                </Grid.Row>
                <GridDivider />
                <Grid.Row className="uc-grid-detail-row">
                  <Grid.Column mobile={6} tablet={4} computer={3}>
                    {t('Assigned Agent', { ns: TRANSLATION_FILES.screens })}
                  </Grid.Column>
                  <Grid.Column mobile={10} tablet={4} computer={5}>
                    <span>{data.assign_to_name || 'N/A'}</span>
                  </Grid.Column>
                  <Grid.Column mobile={6} tablet={4} computer={3}>
                    {t('Agency', { ns: TRANSLATION_FILES.screens })}
                  </Grid.Column>
                  <Grid.Column mobile={10} tablet={4} computer={5}>
                    <span>{data.assign_to_agency_name || 'N/A'}</span>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className="uc-grid-detail-row">
                  <Grid.Column mobile={6} tablet={4} computer={3}>
                    {t('Agent Contact', { ns: TRANSLATION_FILES.screens })}
                  </Grid.Column>
                  <Grid.Column mobile={10} tablet={4} computer={5}>
                    <span>{data.assign_to_mobile_prefix} {data.assign_to_mobile || 'N/A'}</span>
                  </Grid.Column>
                  <Grid.Column mobile={6} tablet={4} computer={3}>
                    {t('Agent Email', { ns: TRANSLATION_FILES.screens })}
                  </Grid.Column>
                  <Grid.Column mobile={10} tablet={4} computer={5}>
                    <span>{data.assign_to_email || 'N/A'}</span>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column className="opportunity-info-notes" mobile={16} tablet={16} computer={4}>
              <SharedNote
                parentType="opportunity"
                parentID={routeParamsID || data.id || ''}
                // defaultPrivacy={(data && data.project && data.project.bnDefaultPrivacy) || ''}
                hasEditAccess
                // isDisabled={this.state.editingBooking}
                setRef={this.setRefOpportunityNote}
                // token={this.props.token}
                // onExpand={this.handleBookingNotesExpand}
                // showExpand={!this.props.isMobile}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <Grid>
                <Grid.Row className="uc-grid-title-row">
                  <Grid.Column width={16}>
                    {t('Attachments', { ns: TRANSLATION_FILES.screens })}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={16}>
                    {formAttachmentsLoading ? (
                      <Loader active inline="centered" size="small" />
                    ) : formAttachmentsError ? (
                      <span style={{ color: '#db2828' }}>{t('Failed to load attachments', { ns: TRANSLATION_FILES.screens })}</span>
                    ) : formAttachments.length === 0 ? (
                      <span className="attachment-empty-text">{t('No attachments found', { ns: TRANSLATION_FILES.screens })}</span>
                    ) : (
                      <div className="attachment-list">
                        {formAttachments.map(att => (
                          <AttachmentItem
                            key={att.id}
                            fileName={att.fileName || t('Attachment', { ns: TRANSLATION_FILES.screens })}
                            downloadUrl={this.getAttachmentUrl(att.id, att.fileName)}
                          />
                        ))}
                      </div>
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Info.mapStateToProps)(Info));



// WEBPACK FOOTER //
// ./src/containers/Opportunities/Overview/Info.jsx